<template>
  <div class="flex flex-col gap-4" :class="errorShow ? 'error' : ''">
    <div class="flex gap-16">
      <label
        v-for="option in options"
        :key="option.id"
        class="input-radio-wrapp
              relative
              flex items-center gap-[10px]
              text-sm text-blue
              cursor-pointer"
      >
        <input
          type="radio"
          :name="name"
          class="absolute opacity-0 peer"
          :checked="option.id === value"
          @change="$emit('input', option.id)"
        />
        <span
          class="input-radio-dot
        flex items-center justify-center w-5 h-5 rounded-full border border-blue duration-100
        before:block before:w-3 before:h-3
        before:rounded-full before:bg-blue
        before:opacity-0 before:scale-50 before:duration-200"
        >
        </span>
        <span>{{ option.text }}</span>
      </label>
    </div>

    <p v-if="errorShow" class="text-xs text-red">{{ errorText }}</p>
  </div>
</template>

<script>
export default {
  name: 'CalculatorRadioButton',
  props: {
    options: {
      type: Array,
      default: [],
    },
    name: String,
    value: String,
    errorShow: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: 'This field is required',
    },
  },
}
</script>
